interface LastSuccessfulDate {
  year: number
  month: number
}

// Utility to get the last successful date from session storage
export const getLastSuccessfulDate = (): LastSuccessfulDate | null => {
  const lastDate = sessionStorage.getItem('lastSuccessfulDate')
  return lastDate ? JSON.parse(lastDate) : null
}

// Utility to set the last successful date in session storage
export const setLastSuccessfulDate = (year: number, month: number) => {
  const lastDate = JSON.stringify({ year, month })
  sessionStorage.setItem('lastSuccessfulDate', lastDate)
}
